import { render, staticRenderFns } from "./VatRateCreateEdit.vue?vue&type=template&id=be2bace0&scoped=true&"
import script from "./VatRateCreateEdit.vue?vue&type=script&lang=js&"
export * from "./VatRateCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./VatRateCreateEdit.vue?vue&type=style&index=0&id=be2bace0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2bace0",
  null
  
)

export default component.exports